/* =========================================================================
   MapleWeld — Contact page behaviour.

   1. Reveal-on-scroll for [data-mwc-rv] (self-contained; does not depend on
      the homepage reveal running on this template).
   2. Deep-linking: the homepage service tiles link here as
      /pages/contact?enquiry=repairs, so the enquiry dropdown arrives already
      set to what the visitor clicked. No retyping, no lost intent.
   3. The department cards do the same thing without a page load, then scroll
      the form into view and flash it so it is obvious what happened.
   ========================================================================= */
(function () {
  'use strict';

  function reveal(root) {
    var items = root.querySelectorAll('[data-mwc-rv]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-mwc-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* Set the enquiry <select> to a value, matching loosely so "repairs",
     "Repairs" and "Machine repairs" all land on the same option. */
  function setEnquiry(select, wanted) {
    if (!select || !wanted) return false;
    var want = String(wanted).trim().toLowerCase();
    var exact = null, partial = null;

    Array.prototype.forEach.call(select.options, function (opt) {
      var v = String(opt.value || '').trim().toLowerCase();
      var t = String(opt.text || '').trim().toLowerCase();
      if (v === want || t === want) { if (!exact) exact = opt; return; }
      if (!partial && want.length > 2 && (v.indexOf(want) > -1 || t.indexOf(want) > -1)) partial = opt;
    });

    var hit = exact || partial;
    if (!hit) return false;
    select.value = hit.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function init() {
    var root = document.querySelector('.mwc');
    if (!root) return;

    reveal(root);

    var select = root.querySelector('[data-mwc-enquiry]');
    var card = root.querySelector('[data-mwc-card]');

    /* 2 — prefill from ?enquiry= */
    try {
      var q = new URLSearchParams(window.location.search).get('enquiry');
      if (q) setEnquiry(select, q);
    } catch (e) { /* older browser: skip, the form still works */ }

    /* 3 — department cards */
    root.querySelectorAll('[data-mwc-dept]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var applied = setEnquiry(select, btn.getAttribute('data-mwc-dept'));
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (applied) {
            card.classList.remove('is-flash');
            void card.offsetWidth;              // restart the animation
            card.classList.add('is-flash');
          }
        }
        var name = root.querySelector('[data-mwc-focus]');
        if (name) setTimeout(function () { name.focus({ preventScroll: true }); }, 420);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
